import Layout from "../layouts/LayoutDefault.jsx";
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import MainContainer from "../components/MainContainer.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import BlogpostSummery from "../components/BlogpostSummery.jsx";
import TitleTextSection from "../components/TitelTextSection.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const BlogsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const pageFromUrl = searchParams.get("page");
  const [currentPageNr, setCurrentPageNr] = useState(() => {
    return pageFromUrl ? Number(pageFromUrl) : 1;
  });

  // If user uses a link with pagenr directly
  useEffect(() => {
    // Page
    const pageFromUrl = searchParams.get("page");
    if (pageFromUrl && Number(pageFromUrl) !== currentPageNr) {
      setCurrentPageNr(Number(pageFromUrl));
    }
  }, [searchParams]);

  const { data, error, loading } = MakeGetRequest({
    route: `get_blogs?page=${currentPageNr}`,
  });

  if (data) {
    const itemsToView = 12;
    const totalPages = Math.ceil(data.count / itemsToView);

    const goToNextPage = () => {
      if (currentPageNr < totalPages) {
        setCurrentPageNr((prevPage) => prevPage + 1);
        navigate(`?page=${currentPageNr + 1}`, { replace: true });
      }
    };

    const goToPreviousPage = () => {
      if (currentPageNr > 1) {
        setCurrentPageNr((prevPage) => prevPage - 1);
        navigate(`?page=${currentPageNr - 1}`, { replace: true });
      }
    };
    return (
      <>
        <Layout
          title="Bloggar"
          description="Hitta blogginlägg från lokala band och musiker"
        >
          <MainContainer>
            <div className="sm:py-4 flex justify-between items-center mb-4">
              <TitleTextSection
                title="Bloggar"
                subtitle="Senaste nyheterna och blogginläggen ifrån Strängnäs"
              />
            </div>

            <div className="space-y-12 ">
              {data.items.map((post, index) => (
                <div key={index} className="grid col-span-1">
                  {index === 6 && <CommercialBanner />}
                  <BlogpostSummery post={post} index={index} />
                </div>
              ))}
            </div>
            <div className="w-full flex justify-center my-10">
              <div className="join shadow-md">
                <button
                  className="join-item btn bg-[#131313] border border-white/10 text-stone-300 hover:bg-neutral-800 disabled:opacity-30 rounded-l-full px-4 font-bold"
                  onClick={goToPreviousPage}
                  disabled={currentPageNr === 1}
                >
                  «
                </button>
                <button className="join-item btn bg-[#131313] border-y border-white/10 border-x-0 text-stone-300 pointer-events-none font-bold">
                  Sida {currentPageNr}{" "}
                  <span className="text-stone-500 font-semibold ml-1">
                    av {totalPages}
                  </span>
                </button>
                <button
                  className="join-item btn bg-[#131313] border border-white/10 text-stone-300 hover:bg-neutral-800 disabled:opacity-30 rounded-r-full px-4 font-bold"
                  onClick={goToNextPage}
                  disabled={currentPageNr === totalPages}
                >
                  »
                </button>
              </div>
            </div>
          </MainContainer>
        </Layout>
      </>
    );
  }
};

export default BlogsPage;
